import CookieConsentPopup from "./components/CookieConsentPopup.svelte";

export function loadGTag() {
	const tag = "G-2KREE3MR0X";
	const script = document.createElement("script");
	script.src = `https://www.googletagmanager.com/gtag/js?id=${tag}`;
	script.async = true;
	document.head.append(script);
	window.dataLayer = window.dataLayer || [];
	function gtag(key: string, value: any){
		window.dataLayer.push(arguments);
	}
	gtag("js", new Date());
	gtag("config", "G-2KREE3MR0X");
}

export const COOKIE_CONSENT_KEY = "COOKIE_CONSENT";

export function checkCookieConsent(): boolean {
	return localStorage.getItem(COOKIE_CONSENT_KEY) !== null;
}

export function setCookieConsent() {
	if (checkCookieConsent()) return;
	localStorage.setItem(COOKIE_CONSENT_KEY, "true");
	loadGTag();
}
